<h2 mat-dialog-title>Modificar rol de integrante</h2>
<mat-dialog-content>
  <div>
    <mat-form-field>
      <mat-label>Tipo de rol</mat-label>
      <mat-select [formControl]="tipo_rol_id" required (selectionChange)="onRolSelect($event)">
        <mat-option *ngFor="let rol of roles" [value]="rol.id">
          {{rol.nombre}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="tipo_rol_id.invalid">
        Debe ingresar un rol
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row" *ngIf="this.tipo_rol_id.value === 6">
    <mat-form-field class="col-xs-6 col-sm-12">
      <input matInput placeholder="Correo electrónico:" type="email" [formControl]="correo_electronico" required
        [disabled]="true">
      <mat-error *ngIf="correo_electronico.invalid">
        Debe ingresar un correo electrónico
      </mat-error>
    </mat-form-field>
  </div>

  <!-- <div *ngIf="needCertificadoNotarial" class="flex">
    <mat-form-field appearance="standard" class="full-width">
      <mat-label>Certificado notarial: *</mat-label>
      <ngx-mat-file-input [formControl]="certificado_notarial" accept=".pdf, .jpeg, .jpg, .png, .gif"
        (change)="onFileChange('certificado_notarial')" placeholder="Certificado notarial">
      </ngx-mat-file-input>
      <mat-icon matSuffix>
        <fa-icon icon="paperclip"></fa-icon>
      </mat-icon>
      <mat-hint align="end">
        <div class="flex" [matTooltip]="certificadoNotarialTooltip">
          <mat-icon>info</mat-icon>
          <span>Más información</span>
        </div>
      </mat-hint>
      <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>
    </mat-form-field>
  </div> -->

  <div *ngIf="needAcreditacionRepresentacion && !linkAcreditacionRepresentacion">
    <mat-form-field appearance="standard" required>
      <mat-label>Acreditación de representación: *</mat-label>
      <ngx-mat-file-input [formControl]="acreditacion_representacion" accept=".pdf, .jpeg, .jpg, .png, .gif"
        (change)="onFileChange('acreditacion_representacion')" placeholder="Acreditación de representación">
      </ngx-mat-file-input>
      <mat-icon matSuffix>
        <fa-icon icon="paperclip"></fa-icon>
      </mat-icon>
      <mat-hint align="end">
        <div class="flex">
          <mat-icon>info</mat-icon>
          <span>Mención en el certificado o carta poder</span>
        </div>
      </mat-hint>
      <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png, .gif</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png, .gif, menor a 10 MB</mat-error>
    </mat-form-field>
  </div>
  <ng-container *ngIf="needAcreditacionRepresentacion && linkAcreditacionRepresentacion">
    <a href="{{linkAcreditacionRepresentacion}}" target="_blank">Ver acreditación de representación</a>
    <ng-container>
      <rpe-ui-button icon="upload" (onClick)="uploadNewCertificadoNotarial()">Subir nuevo archivo</rpe-ui-button>
    </ng-container>
  </ng-container>

  <div *ngIf="isAnalista">
    <span>Seleccione al menos un laboratorio:</span>
    <div *ngFor="let laboratorio of data.laboratorios" class="lab-checkbox">
      <mat-checkbox [checked]="selectedLabs.includes(laboratorio.id)" (change)="onLabChange($event, laboratorio)">
        {{ laboratorio.nombre }}
      </mat-checkbox>
    </div>
  </div>


  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Guardando cambios...</span>
  </div>

  <div class="actions">
    <button mat-stroked-button (click)="dialogRef.close()" [disabled]="loading">Cancelar</button>
    <button mat-stroked-button (click)="onSubmit()" [disabled]="loading">Guardar</button>
  </div>
</mat-dialog-content>